import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enUS from '../../locale/en_CA.json';
import frFR from '../../locale/fr_CA.json';

i18n
    // Detect user language
    .use(LanguageDetector)
    // Pass the i18n instance to react-i18next  
    .use(initReactI18next)
    // Initialize i18next
    .init({
        resources: {
            en: {
                translation: enUS,
            },
            fr: {
                translation: frFR,
            },
        },
        fallbackLng: 'en',
        debug: import.meta.env.DEV,
        interpolation: {
            escapeValue: false, // React already escapes values
        },
        detection: {
            // Order of language detection - check cookie first for cross-subdomain sharing
            order: ['cookie', 'localStorage', 'navigator', 'htmlTag'],
            // Cache user language preference in both cookie and localStorage
            caches: ['cookie', 'localStorage'],
            // Cookie configuration for cross-subdomain sharing
            lookupCookie: 'i18nextLng',
            cookieOptions: {
                path: '/',
                domain: import.meta.env.PROD ? '.admitone.com' : undefined,
                sameSite: 'lax',
                secure: import.meta.env.PROD,
            },
            // Use the same localStorage key as web-secure (fallback)
            lookupLocalStorage: 'i18nextLng',
        },
    });

export default i18n;

